import { useLensApp } from "../useLensApp.jsx";

export default function LogSection() {
  const { logLines } = useLensApp();
  return (
    <section>
      <h3>Log</h3>
      <div className="log">
        {logLines.map((line, index) => (
          <div key={`${index}-${line.slice(0, 16)}`}>{line}</div>
        ))}
      </div>
    </section>
  );
}
